export default __webpack_public_path__ + "52e97a2624339de066b874d1a7c16490.png";